import { apiClient } from './client';
import { LoginRequest, LoginResponse, AdminUser } from '../types';

export const authApi = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.login(credentials);
    // Backend returns ApiSuccess wrapper, so response is the unwrapped data
    return response;
  },

  refreshToken: async (refreshToken: string) => {
    const response = await apiClient.refreshToken(refreshToken);
    return response;
  },

  getMe: async (): Promise<AdminUser> => {
    const response = await apiClient.getMe();
    // Backend returns ApiSuccess(AdminAuthResponse) which contains user
    return response.user;
  },

  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
  },
};
